import { Icon } from '@hai/ui-react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useWatchObject } from 'src/js/store/use-watch';
import { assetsStore, fetchAssets } from './assets-store';
import systemInfo from 'src/js/data/systemInfo';
import { useNavigate, useParams } from 'react-router-dom';
import { triggerEvent, watchEvent } from 'src/js/events';
import { useAdaptiveFetch } from 'src/js/hook/use-adaptive-fetch';
import { formatBytes } from 'src/js/helper/duration-format-helper';
import { fetchStorage, storageStore } from './storage-store';
import { StorageUsageHeader } from './storage-usage-header';

import defaultThumbnail from 'src/images/thumbnail-default.jpg'; // FIXME cache or pre-cache. When system goes offline it tries to fetch it again and appears as not found image.

interface Props {}

export type AssetPageParameters = {
  id?: string;
};

// WORK IN PROGRESS, not finished
export const AssetSingle = (_props: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams<AssetPageParameters>();
  // console.log('id asset single', id);
  //  const [loading, setLoading] = useState(true);

  const [, setAssets] = useState(assetsStore);
  useWatchObject(assetsStore, setAssets);

  useEffect(() => {
    if (!systemInfo.storage) {
      navigate('/streaming');
      return;
    }
  }, []);

  const interval = 5000;
  useAdaptiveFetch(() => fetchAssets(t), interval);
  useAdaptiveFetch(() => systemInfo.storage && fetchStorage(t), interval * 2);

  useWatchObject(assetsStore, () => {
    // setLoading(false);
    triggerEvent('assets-fetched');
  });

  const shouldReloadData = () => {
    //fetchVideoInputs();
    fetchAssets(t).then(() => {
      //
    });
  };

  watchEvent('preset-load', () => {
    shouldReloadData();
  });

  const model = assetsStore.find((a) => a.id === id);

  return (
    <>
      <div className="mt-32px">
        <StorageUsageHeader storage={storageStore.internal} />
        <div className="hai-p-0">
          <div id="single-asset-table">Single Asset</div>
          {model &&
            (model.status === 'Active' ? (
              <div className="assetThumbnail">
                <img className="thumbnail" src={defaultThumbnail} />
                <span>REC...</span>
                {model.segmented && (
                  <div className="topRightOverlay">
                    {model.segments.length.toString()}
                    <Icon iconname="Assets" className="gray-07-svg" />
                  </div>
                )}
              </div>
            ) : (
              <div className="assetThumbnail">
                <img
                  className="fs-mask"
                  src={
                    model.parent
                      ? `/apis/asset/${model.parent.id}/thumbnail/${model.id}`
                      : `/apis/asset/${model.id}/thumbnail`
                  }
                />
                {model.segmented && (
                  <div className="topRightOverlay">
                    <span className="text">{model.segments.length.toString()}</span>
                    <Icon iconname="Assets" className="gray-07-svg" />
                  </div>
                )}
                <div className="mediaDetails">
                  <span className="text">Size</span>
                  <span>{formatBytes(Number(model.size))}</span>
                  <span className="text">Duration</span>
                  <span>{model.duration}</span>
                  <span className="text">Creation Date</span>
                  <span>{model.ctime}</span>
                </div>
              </div>
            ))}
        </div>
      </div>
      {/*deleteShown && (
        <GenericDeleteModal
          title="assets.deleteModal.title"
          // if we want transition titleInProgress="assets.deleteModal.titleInProgress"
       //   itemsToDelete={model.id}
          onCancel={() => {
            hideDelete();
          }}
          //onDelete={onBulkDeleteProceed}
          onSuccess={hideDelete}
        />
      )*/}
      <br />
    </>
  );
};
